"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = exports.SWAPTION_TYPE = void 0;
const lodash_functions_1 = require("../../../../util/lodash-functions");
const default_session_1 = require("../../../../session/default-session");
const surfaces_provider_1 = require("../surfaces-provider");
exports.SWAPTION_TYPE = 'Swaption';
function Definition(params, surfaceTag) {
    let parameters;
    if ((0, lodash_functions_1.isPlainObject)(params)) {
        parameters = params;
    }
    else {
        parameters = {
            surfaceTag,
            instrumentCode: params,
        };
    }
    const { outputs, instrumentCode, extendedParams, discountingType } = parameters, instrumentDefinition = __rest(parameters, ["outputs", "instrumentCode", "extendedParams", "discountingType"]);
    const requestItem = Object.assign(Object.assign({}, instrumentDefinition), { underlyingDefinition: { instrumentCode, discountingType }, underlyingType: exports.SWAPTION_TYPE });
    return {
        getData(session = (0, default_session_1.getDefault)()) {
            const financialContracts = new surfaces_provider_1.SurfacesProvider(session);
            return financialContracts.getSurfaces([requestItem], { extendedParams, outputs });
        },
        /** @internal */
        getInstrument() {
            return requestItem;
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2lwYS9zdXJmYWNlcy9zd2FwdGlvbi9kZWZpbml0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7O0FBRUEsd0VBQWtFO0FBQ2xFLHlFQUFpRTtBQUNqRSw0REFBd0Q7QUFFM0MsUUFBQSxhQUFhLEdBQUcsVUFBVSxDQUFDO0FBSXhDLFNBQWdCLFVBQVUsQ0FDdEIsTUFBNkMsRUFDN0MsVUFBbUI7SUFFbkIsSUFBSSxVQUF3QyxDQUFDO0lBRTdDLElBQUksSUFBQSxnQ0FBYSxFQUFDLE1BQU0sQ0FBQyxFQUFFLENBQUM7UUFDeEIsVUFBVSxHQUFHLE1BQXNDLENBQUM7SUFDeEQsQ0FBQztTQUFNLENBQUM7UUFDSixVQUFVLEdBQUc7WUFDVCxVQUFVO1lBQ1YsY0FBYyxFQUFFLE1BQWdCO1NBQ25DLENBQUM7SUFDTixDQUFDO0lBQ0QsTUFBTSxFQUFFLE9BQU8sRUFBRSxjQUFjLEVBQUUsY0FBYyxFQUFFLGVBQWUsS0FBOEIsVUFBVSxFQUFuQyxvQkFBb0IsVUFBSyxVQUFVLEVBQWxHLGtFQUFxRixDQUFhLENBQUM7SUFDekcsTUFBTSxXQUFXLG1DQUNWLG9CQUFvQixLQUN2QixvQkFBb0IsRUFBRSxFQUFFLGNBQWMsRUFBRSxlQUFlLEVBQUUsRUFDekQsY0FBYyxFQUFFLHFCQUFhLEdBQ2hDLENBQUM7SUFFRixPQUFPO1FBQ0gsT0FBTyxDQUFDLFVBQW1CLElBQUEsNEJBQVUsR0FBRTtZQUNuQyxNQUFNLGtCQUFrQixHQUFHLElBQUksb0NBQWdCLENBQUMsT0FBTyxDQUFDLENBQUM7WUFFekQsT0FBTyxrQkFBa0IsQ0FBQyxXQUFXLENBQUMsQ0FBQyxXQUFXLENBQUMsRUFBRSxFQUFFLGNBQWMsRUFBRSxPQUFPLEVBQUUsQ0FBQyxDQUFDO1FBQ3RGLENBQUM7UUFDRCxnQkFBZ0I7UUFDaEIsYUFBYTtZQUNULE9BQU8sV0FBVyxDQUFDO1FBQ3ZCLENBQUM7S0FDSixDQUFDO0FBQ04sQ0FBQztBQWhDRCxnQ0FnQ0MifQ==